export default __webpack_public_path__ + "static/media/Prancheta 6.f0b7d5fb.svg";